module.exports = __webpack_public_path__ + "static/logo-grey.1d033414.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo-grey.svg
// module id = 1768
// module chunks = 114276838955818